// src/components/MultilingualInput/MultilingualInput.jsx

import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const MultilingualInput = ({
  label,
  field,
  formData,
  onChange,
  placeholder,
  required,
  isTextArea = false,
  rows = 3,
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-3">
      <label htmlFor={`${field}_en`} className="form-label">
        {label} ({t('english')}) {required && <span className="text-danger">*</span>}
      </label>
      {isTextArea ? (
        <textarea
          id={`${field}_en`}
          name={`${field}_en`}
          className={`form-control ${!(formData.en && formData.en.trim()) ? 'is-invalid' : ''}`}
          placeholder={placeholder.en}
          value={formData.en}
          onChange={onChange}
          rows={rows}
          required={required}
        ></textarea>
      ) : (
        <input
          type="text"
          id={`${field}_en`}
          name={`${field}_en`}
          className={`form-control ${!(formData.en && formData.en.trim()) ? 'is-invalid' : ''}`}
          placeholder={placeholder.en}
          value={formData.en}
          onChange={onChange}
          required={required}
        />
      )}
      {required && !(formData.en && formData.en.trim()) && (
        <div className="invalid-feedback">{t(`${field}.en.required`)}</div>
      )}

      <label htmlFor={`${field}_ar`} className="form-label mt-3">
        {label} ({t('arabic')}) {required && <span className="text-danger">*</span>}
      </label>
      {isTextArea ? (
        <textarea
          id={`${field}_ar`}
          name={`${field}_ar`}
          className={`form-control ${!(formData.ar && formData.ar.trim()) ? 'is-invalid' : ''}`}
          placeholder={placeholder.ar}
          value={formData.ar}
          onChange={onChange}
          rows={rows}
          required={required}
        ></textarea>
      ) : (
        <input
          type="text"
          id={`${field}_ar`}
          name={`${field}_ar`}
          className={`form-control ${!(formData.ar && formData.ar.trim()) ? 'is-invalid' : ''}`}
          placeholder={placeholder.ar}
          value={formData.ar}
          onChange={onChange}
          required={required}
        />
      )}
      {required && !(formData.ar && formData.ar.trim()) && (
        <div className="invalid-feedback">{t(`${field}.ar.required`)}</div>
      )}
    </div>
  );
};

MultilingualInput.propTypes = {
  label: PropTypes.string.isRequired,
  field: PropTypes.string.isRequired,
  formData: PropTypes.shape({
    en: PropTypes.string,
    ar: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.shape({
    en: PropTypes.string,
    ar: PropTypes.string,
  }).isRequired,
  required: PropTypes.bool,
  isTextArea: PropTypes.bool,
  rows: PropTypes.number,
};

MultilingualInput.defaultProps = {
  required: false,
  isTextArea: false,
  rows: 3,
};

export default MultilingualInput;
